module.exports = __webpack_public_path__ + "img/avatar-s-16.88e40556.png";